






















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HelpContent extends Vue { 
    openHelp(){
        this.$bvModal.show('modal-help');
    }
    get checkTitle():boolean{            
        if (this.$slots.modalHelpTitle===undefined) return false;

        return true;
    }
    get checkFooter():boolean{
        if (this.$slots.modalHelpFooter===undefined) return false;
        
        return true;

    }
}
